module.exports = __webpack_public_path__ + "assets/img/model-1.c0e4211a.png";